import axios from "axios";
import { API_URL, FOLDERPATH } from "../Constants/config";
import { toast } from "react-toastify";
import { UPLOAD_ARN_LOADING, UPLOAD_ARN_SUCCESS, UPLOAD_ARN_FAILED } from "../Constants/uploadArnConstants";
import { handleApiError } from "../Helper/actionHelper";

export const getArnUpload = (record) => async (dispatch) => {
  try {
    let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate'));  


    const demoFormaData = { 
      token:
      userLocalData.id,
      "docid": 26,
      // "group": 10,
      //"referenceNo": "291664450159",
    };

    let formData = new FormData();
    Object.keys(demoFormaData).map((k) => {
      formData.set(k, demoFormaData[k])
    })

      formData.append( "arn[]",record);

      
    dispatch({ type: UPLOAD_ARN_LOADING });

   

    //return false;
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    //axios.defaults.baseURL = API_URL;
    const { data } = await axios.post(FOLDERPATH +
      "/ClientApi/uploadARNDocument", 
      formData,
      {
     headers: headers,
      }
    );

    dispatch({
      type: UPLOAD_ARN_SUCCESS,
      payload: data,
    });

    toast.success(data.msg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

    handleApiError(data);

  } catch (error) {
    dispatch({
      type: UPLOAD_ARN_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });

    handleApiError(error);
  }
};